import { useQuery } from "react-query";
import { apiListSalesCompanyTypes } from "../apiCoreV3/salesCompany/apiListSalesCompanyTypes";

export default function useSalesCompanyTypesQuery() {
  return useQuery(["salesCompanyTypes"], apiListSalesCompanyTypes, {
    staleTime: Infinity,
    cacheTime: Infinity,
  });
}
